export default "__VITE_ASSET__grVdAAk8__"